import React from "react";
import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, subtitle, align = "center" }) => {
  const alignment = align === "left" ? "text-left items-start" : "text-center items-center mx-auto";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24, filter: "blur(6px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`flex flex-col gap-4 max-w-2xl ${alignment}`}
    >
      {eyebrow && (
        <span className="inline-flex items-center gap-2 self-start rounded-full glass px-3 py-1 text-xs uppercase tracking-[0.18em] text-neon-g">
          <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--neon-g)] shadow-[0_0_10px_var(--neon-g)]" />
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] leading-[1.05]">
        {title}
      </h2>
      {subtitle && (
        <p className="text-muted-brand text-base sm:text-lg leading-relaxed">{subtitle}</p>
      )}
    </motion.div>
  );
};
